export default __webpack_public_path__ + "static/media/desktopLogin.ee2c754b.png";